import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "@gemini/ui";
import { useContactContext, useContactSections } from "@/contexts/contact";
import { useI18n } from "@/contexts/i18n";
import { brandConfiguration } from "@/brands/config";
import { useContactingTestId } from "@/hooks";
import { ContactFormWithLead } from "../ContactForm/ContactFormWithLead";
export const ContactModal = ({ defaultValues, }) => {
    const { t } = useI18n();
    const rootTestID = useContactingTestId("ContactModal");
    const { toggleModal, closeModal, isOpen, avZone } = useContactContext();
    const { contactModalTitlePrivate, contactModalTitleAgency } = brandConfiguration.lokaliseSpecificKeys;
    const isPrivateOwner = useContactSections().contactCard.isPrivateOwner;
    const onOpenChange = () => {
        toggleModal({
            av_zone: avZone,
            legacyTrackingInfos: "detail-right", //tracking GA3 for harvest
        });
    };
    return (_jsx(Modal, { testId: rootTestID, title: t(isPrivateOwner ? contactModalTitlePrivate : contactModalTitleAgency), titleAs: "h2", trigger: () => null, isOpen: isOpen, onOpenChange: onOpenChange, isDismissable: true, children: _jsx(ContactFormWithLead, { isModal: true, av_zone: avZone, close: closeModal, contactFormRootTestId: "ContactModal.ContactForm", defaultValues: defaultValues }) }));
};
